import React from 'react';
import propTypes from 'prop-types';
import GroupedCarrierSections from 'tailwind-components/GroupedCarrierSections/GroupedCarrierSections';
import UntappedRecommendationCarrierCard from './UntappedRecommendationCarrierCard';

function UntappedCarrierGrid({ carriers, onSeeStates }) {
  if (!carriers?.length) return null;

  return (
    <div className='equal-rows simple-carrier-grid grid w-full min-w-0 gap-1.5'>
      {carriers.map(carrier => (
        <div
          key={carrier.name}
          className='flex min-h-[90px] min-w-0 w-full h-full'
        >
          <UntappedRecommendationCarrierCard
            name={carrier.name}
            carrierIcon={carrier.carrierIcon}
            carrierIconColor={carrier.carrierIconColor}
            considersStates={carrier.considersStates}
            states={carrier.untappedStates ?? []}
            onSeeStates={onSeeStates}
          />
        </div>
      ))}
    </div>
  );
}

UntappedCarrierGrid.propTypes = {
  carriers: propTypes.arrayOf(propTypes.object),
  onSeeStates: propTypes.func
};

export default function UntappedCarrierSections({
  groupedCarriers = [],
  onSeeStates
}) {
  const renderGrid = carriers => (
    <UntappedCarrierGrid carriers={carriers} onSeeStates={onSeeStates} />
  );

  return (
    <GroupedCarrierSections
      groupedCarriers={groupedCarriers}
      filterLegendsForGrid={false}
      wrapperClassName='flex w-full flex-col gap-6'
      sectionClassName='flex flex-col gap-3'
      renderMainGrid={renderGrid}
      renderSubgroupGrid={renderGrid}
    />
  );
}

UntappedCarrierSections.propTypes = {
  groupedCarriers: propTypes.arrayOf(
    propTypes.shape({
      parentGroupName: propTypes.string.isRequired,
      carriersWithoutSubgroup: propTypes.arrayOf(propTypes.object).isRequired,
      subgroups: propTypes.arrayOf(
        propTypes.shape({
          groupName: propTypes.string.isRequired,
          carriers: propTypes.arrayOf(propTypes.object).isRequired
        })
      )
    })
  ),
  onSeeStates: propTypes.func
};
